/*=========================================================================================
  File Name: moduleSiteseting.js
  Description: Site Setting
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import state from './moduleSitesettingState';
import mutations from './moduleSitesettingMutations';
import actions from './moduleSitesettingActions';
import getters from './moduleSitesettingGetters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
